module.exports = __webpack_public_path__ + "img/222.6ca77a3b.jpg";